
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  Supplier.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\Supplier.ts

import {InseeUniteLegale } from "./InseeUniteLegale";
import {InseeEtablissement } from "./InseeEtablissement";
import {IntraTvaCheckerResult } from "./IntraTvaCheckerResult";
import {CreditSafeCompany } from "./CreditSafeCompany";
import {FT_Extract_CreditSafe_Report_Result } from "./FT_Extract_CreditSafe_Report_Result";
import {Address } from "./Address";
import {SupplierAgency } from "./SupplierAgency";
import {SupplierAnswer } from "./SupplierAnswer";
import {SupplierContact } from "./SupplierContact";
import {SupplierDocument } from "./SupplierDocument";
import {SupplierFamily } from "./SupplierFamily";
import {Currency } from "./Currency";
import {ApeCod } from "./ApeCod";
import {LegalForm } from "./LegalForm";
import {SupplierNote } from "./SupplierNote";
import {SupplierUpdateComment } from "./SupplierUpdateComment";
import {SupplierStatut } from "./SupplierStatut";
import {SupplierPerimeter } from "./SupplierPerimeter";
import {SupplierPurchaseComment } from "./SupplierPurchaseComment";
import {CreditSafeData } from "./CreditSafeData";
import {SupplierInseeData } from "./SupplierInseeData";
import {Flag } from "./Flag";
import {SupplierPilotageDepens } from "./SupplierPilotageDepens";
import {SupplierAccHisto } from "./SupplierAccHisto";
import {SupplierWF } from "./SupplierWF";
import {SupplierRseAnswer } from "./SupplierRseAnswer";
export class Supplier {

  // InseeUniteLegale UnitLegale
  public UnitLegale: InseeUniteLegale=null;

  // InseeEtablissement Etablissement
  public Etablissement: InseeEtablissement=null;

  // InseeEtablissement[] Etablissements
  public Etablissements: InseeEtablissement[]=[];

  // IntraTvaCheckerResult IntraVAT
  public IntraVAT: IntraTvaCheckerResult=null;

  // string CreditSafeCompanyId
  public CreditSafeCompanyId?: string=null;

  // CreditSafeCompany CreditSafeCompany
  public CreditSafeCompany: CreditSafeCompany=null;

  // FT_Extract_CreditSafe_Report_Result CreditSafeReport
  public CreditSafeReport: FT_Extract_CreditSafe_Report_Result=null;

  // int Id
  public Id: number=0;

  // string SupplierName
  public SupplierName?: string=null;

  // int? LegalFormId
  public LegalFormId?: number=null;

  // string Siret
  public Siret?: string=null;

  // string Rsa
  public Rsa?: string=null;

  // string Duns
  public Duns?: string=null;

  // string TvaIntra
  public TvaIntra?: string=null;

  // string FunctionalId
  public FunctionalId?: string=null;

  // string WebSite
  public WebSite?: string=null;

  // int? ApeId
  public ApeId?: number=null;

  // int? WithAgencies
  public WithAgencies?: number=null;

  // string InternalContactFirstname
  public InternalContactFirstname?: string=null;

  // string InternalContactLastname
  public InternalContactLastname?: string=null;

  // string InternalContactEmail
  public InternalContactEmail?: string=null;

  // int StatutId
  public StatutId: number=0;

  // DateTime? InternalDemandDate
  public InternalDemandDate?: Date=null;

  // string LngCod
  public LngCod?: string=null;

  // string GroupName
  public GroupName?: string=null;

  // string HQSiret
  public HQSiret?: string=null;

  // string ApiSirenResult
  public ApiSirenResult?: string=null;

  // string FamilyOther
  public FamilyOther?: string=null;

  // byte? TopWorkAtClient
  public TopWorkAtClient?: number=null;

  // DateTime? AccDatDeb
  public AccDatDeb?: Date=null;

  // DateTime? AccDatFin
  public AccDatFin?: Date=null;

  // int? NbEmployees
  public NbEmployees?: number=null;

  // int? NbWorkHours
  public NbWorkHours?: number=null;

  // int? NbWorkAccLostDays
  public NbWorkAccLostDays?: number=null;

  // int? NbWorkAccStop
  public NbWorkAccStop?: number=null;

  // int? NbWorkAccNoStop
  public NbWorkAccNoStop?: number=null;

  // decimal? TG
  public TG?: number=null;

  // decimal? TF1
  public TF1?: number=null;

  // decimal? TF2
  public TF2?: number=null;

  // int RefStep
  public RefStep: number=0;

  // int? PayCurId
  public PayCurId?: number=null;

  // int? OrderCurId
  public OrderCurId?: number=null;

  // byte TopAffacturage
  public TopAffacturage: number=0;

  // string AffacturageName
  public AffacturageName?: string=null;

  // string AffacturageSiret
  public AffacturageSiret?: string=null;

  // string AffacturagePhone
  public AffacturagePhone?: string=null;

  // string AffacturageContactName
  public AffacturageContactName?: string=null;

  // string AffacturageEmail
  public AffacturageEmail?: string=null;

  // int? AddrFacId
  public AddrFacId?: number=null;

  // byte TopFacDemat
  public TopFacDemat: number=0;

  // string FacSendEmail
  public FacSendEmail?: string=null;

  // string FacReturnEmail
  public FacReturnEmail?: string=null;

  // string PaySendEmail
  public PaySendEmail?: string=null;

  // string DocComments
  public DocComments?: string=null;

  // string DocQualComments
  public DocQualComments?: string=null;

  // string GlobalComments
  public GlobalComments?: string=null;

  // string RejectedApiSirenResult
  public RejectedApiSirenResult?: string=null;

  // string NumTiers
  public NumTiers?: string=null;

  // int? LastWfId
  public LastWfId?: number=null;

  // string HtmlRecap
  public HtmlRecap?: string=null;

  // int? MotifValId
  public MotifValId?: number=null;

  // int? MotifRefusId
  public MotifRefusId?: number=null;

  // string EndelComments
  public EndelComments?: string=null;

  // int? TopNational
  public TopNational?: number=null;

  // int? TopGroupement
  public TopGroupement?: number=null;

  // int? TopConcurrent
  public TopConcurrent?: number=null;

  // int? QualityFlagId
  public QualityFlagId?: number=null;

  // string QualityComments
  public QualityComments?: string=null;

  // decimal? CmdMntYear
  public CmdMntYear?: number=null;

  // decimal? FacMntYear
  public FacMntYear?: number=null;

  // int? duplicatedId
  public duplicatedId?: number=null;

  // string duplicatedComments
  public duplicatedComments?: string=null;

  // string DemandReason
  public DemandReason?: string=null;

  // DateTime? FrameworkContractDate
  public FrameworkContractDate?: Date=null;

  // int? FrameworkContractPafDocId
  public FrameworkContractPafDocId?: number=null;

  // string RoutageEmail
  public RoutageEmail?: string=null;

  // string RoutageCod
  public RoutageCod?: string=null;

  // bool? TopRFE
  public TopRFE?: boolean=null;

  // Address FacAddress
  public FacAddress: Address=null;

  // ICollection<SupplierAgency> SupplierAgencies
  public SupplierAgencies: SupplierAgency[]=[];

  // ICollection<SupplierAnswer> SupplierAnswers
  public SupplierAnswers: SupplierAnswer[]=[];

  // ICollection<SupplierContact> SupplierContacts
  public SupplierContacts: SupplierContact[]=[];

  // ICollection<SupplierDocument> SupplierDocuments
  public SupplierDocuments: SupplierDocument[]=[];

  // ICollection<SupplierFamily> SupplierFamilies
  public SupplierFamilies: SupplierFamily[]=[];

  // Currency OrderCurrency
  public OrderCurrency: Currency=null;

  // Currency PayCurrency
  public PayCurrency: Currency=null;

  // ApeCod ApeCod
  public ApeCod: ApeCod=null;

  // LegalForm LegalForm
  public LegalForm: LegalForm=null;

  // ICollection<SupplierNote> SupplierNotes
  public SupplierNotes: SupplierNote[]=[];

  // ICollection<SupplierUpdateComment> SupplierUpdateComments
  public SupplierUpdateComments: SupplierUpdateComment[]=[];

  // SupplierStatut SupplierStatut
  public SupplierStatut: SupplierStatut=null;

  // ICollection<SupplierPerimeter> SupplierPerimeters
  public SupplierPerimeters: SupplierPerimeter[]=[];

  // ICollection<SupplierPurchaseComment> SupplierPurchaseComments
  public SupplierPurchaseComments: SupplierPurchaseComment[]=[];

  // ICollection<CreditSafeData> CreditSafeDatas
  public CreditSafeDatas: CreditSafeData[]=[];

  // SupplierInseeData SupplierInseeData
  public SupplierInseeData: SupplierInseeData=null;

  // Flag Flag
  public Flag: Flag=null;

  // ICollection<SupplierPilotageDepens> SupplierPilotageDepenses
  public SupplierPilotageDepenses: SupplierPilotageDepens[]=[];

  // ICollection<SupplierAccHisto> SupplierAccHistoes
  public SupplierAccHistoes: SupplierAccHisto[]=[];

  // SupplierWF SupplierWF
  public SupplierWF: SupplierWF=null;

  // ICollection<SupplierWF> SupplierWFs
  public SupplierWFs: SupplierWF[]=[];

  // ICollection<SupplierRseAnswer> SupplierRseAnswers
  public SupplierRseAnswers: SupplierRseAnswer[]=[];
}